import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Bank Details", -1)
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, "Bank address: " + _toDisplayString(_ctx.bank.toBase58()), 1),
    _createElementVNode("div", _hoisted_4, "Bank manager: " + _toDisplayString(_ctx.bankAcc.bankManager.toBase58()), 1),
    _createElementVNode("div", _hoisted_5, "Vault count: " + _toDisplayString(_ctx.bankAcc.vaultCount), 1),
    _createElementVNode("div", _hoisted_6, " Whitelisted creators: " + _toDisplayString(_ctx.bankAcc.whitelistedCreators), 1),
    _createElementVNode("div", _hoisted_7, "Whitelisted mints: " + _toDisplayString(_ctx.bankAcc.whitelistedMints), 1)
  ]))
}